module.exports = __webpack_public_path__ + "img/nongMin5.65f5ab4d.png";